import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";

import { SearchBarFiltersProps } from "../../constants/constants";
import CustomMultiSelect from "./custom-multi-select";
import {
  capitalizeWords,
  handleGoToFirstPage,
} from "../../helpers/idx-common-helpers";
import { PropertyTransactionTypesEnum } from "dash-common";
import { camelCase } from "lodash";
import { useTranslation } from "react-i18next";

export const PropertyTransactionTypeFilter = ({
  filters,
  mainColor,
  mainColorLight,
  textColor,
  setFilters,
  isMobile = false,
  goToFirstPage,
}: SearchBarFiltersProps) => {
  const { t } = useTranslation("pages");

  const selectedType = filters.transactionType[0];

  async function addTransactionTypeFilter(
    transactionType: PropertyTransactionTypesEnum
  ) {
    setFilters((draft) => {
      const index = draft.transactionType.findIndex(
        (item) => item === transactionType
      );
      if (index === -1) {
        draft.transactionType = [];
        draft.transactionType.push(transactionType);
        return;
      }
    });

    handleGoToFirstPage(isMobile, goToFirstPage);
  }

  // Convert strings back to enum values
  const handleMobileSelectChange = (values: string[]) => {
    setFilters((draft) => {
      const index = draft.transactionType.findIndex(
        (item) => item === values[1]
      );
      if (index === -1) {
        draft.transactionType = [];
        draft.transactionType.push(
          PropertyTransactionTypesEnum[
            values[1] as keyof typeof PropertyTransactionTypesEnum
          ]
        );
        return;
      }
    });
  };

  const getMobileSelectOptions = () => {
    return Object.values(PropertyTransactionTypesEnum).map((type) => ({
      value: type,
      label: capitalizeWords(type),
    }));
  };

  return isMobile ? (
    <>
      <CustomMultiSelect
        className="w-full"
        value={filters.transactionType}
        options={getMobileSelectOptions()}
        placeholder="Select transaction"
        onChange={handleMobileSelectChange}
        isSearchable={false}
      />
    </>
  ) : (
    <Popover>
      <PopoverButton
        style={{
          backgroundColor: !!filters.transactionType.length
            ? mainColor
            : mainColorLight,
          color: !!filters.transactionType.length ? "white" : mainColor,
        }}
        className={`text-sm flex gap-2 items-center rounded-full py-2 px-4 hover:brightness-75`}
      >
        <span>
          {t(
            `forms:labels.propertyTransactionTypes.${camelCase(selectedType)}`
          )}
        </span>
        <FiChevronDown />
      </PopoverButton>
      <PopoverPanel
        anchor="bottom end"
        className="bg-white drop-shadow border rounded-lg mt-1"
        style={{ color: textColor }}
      >
        {Object.values(PropertyTransactionTypesEnum).map((status, index) => (
          <button
            onClick={() => addTransactionTypeFilter(status)}
            className="flex items-center gap-2 px-6 py-2 hover:font-bold w-full"
            key={index}
          >
            <input
              checked={
                !!filters.transactionType.find((item) => item === status)
              }
              type="checkbox"
              id={status.toString()}
              readOnly
            />
            <span className="capitalize text-slate-700">
              {status.toLowerCase().split("_").join(" ")}
            </span>
          </button>
        ))}
      </PopoverPanel>
    </Popover>
  );
};
